import { apiSlice } from "../../app/api/apiSlice";

export const identitasApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getIdentitas: builder.query({
      query: (schoolUuid) => ({
        url: "/identitas",
        method: "GET",
        params: schoolUuid ? { schoolUuid } : {},
      }),
      providesTags: ["Identitas"],
    }),
    getIdentitasSekolah: builder.query({
      query: () => "/identitas-sekolah",
      providesTags: ["Identitas"],
    }),
    getStatistikSekolah: builder.query({
      query: () => "/statistik-sekolah",
    }),
    getIdentitasById: builder.query({
      query: (id) => ({
        url: `/identitas/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "Identitas", id }],
    }),
    createIdentitas: builder.mutation({
      query: (data) => ({
        url: "/identitas",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Identitas"],
    }),
    updateIdentitas: builder.mutation({
      query: ({ id, data }) => ({
        url: `/identitas/${id}`,
        method: "PATCH",
        body: data,
        formData: true,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Identitas", id },
        "Identitas",
      ],
    }),
  }),
});

export const {
  useGetIdentitasQuery,
  useGetIdentitasSekolahQuery,
  useGetStatistikSekolahQuery,
  useGetIdentitasByIdQuery,
  useCreateIdentitasMutation,
  useUpdateIdentitasMutation,
} = identitasApiSlice;
